export const NEW_LAYOUT_CONTAINER_ID = "new-layout-container";
